import noodleApiClient, { ApiDefinition } from '@noodleApi';
import buildPath from '../utilities/buildPath';

type ThisApi = ApiDefinition['/workflows/user-workflows/:userWorkflowId/questionnaires/{questionnaireTemplateSlug}']['GET'];
type Input = ThisApi['params'];

const getQuestionnaireIdByUserWorkflow = async ({ questionnaireTemplateSlug, userWorkflowId }: Input): Promise<ThisApi['response']> => {
  const path = buildPath<ThisApi>('/workflows/user-workflows/{userWorkflowId}/questionnaires/{questionnaireTemplateSlug}', { questionnaireTemplateSlug, userWorkflowId});
  const data = await noodleApiClient.get(path);
  return data.data;
};

export default getQuestionnaireIdByUserWorkflow;
